import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
/* import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'; */
import { withCookies } from 'react-cookie';

import {
  registerFarmerSocialAction,
  registerOrgsSocialAction,
} from '../../Actions/appAction';

import LanguageContext from '../common/languageContext';

class SocialLogin extends Component {
  componentDidUpdate(prevProps) {
    const {
      isRegistered, history, cookies, userData,
    } = this.props;
    if (isRegistered !== prevProps.isRegistered && isRegistered) {
      cookies.set('userData', userData, { path: '/' });
      const { data } = userData;
      const { roles } = data;
      if (roles[0].roleName === 'farmer') {
        history.push('/myaccount');
      } else {
        history.push('/setup/step1');
      }
    }
  }

  responseGoogle = (response) => {
    console.log('response=============', response);
    const {
      registerFarmer,
      accountType,
      accountTypeName,
      registerOrgsSocial,
    } = this.props;
    if (accountTypeName !== 'Farmer') {
      const submitData = {
        demographicesDetails: {},
      };
      const data = {};
      // const gName = response.profileObj.name;
      const gNameSplit = response.profileObj.name.split(' ');
      const [firstName, ...lastName] = gNameSplit;
      data.firstName = firstName;
      data.lastName = lastName.join(' ');
      data.emailID = response.profileObj.email;
      data.googleId = response.profileObj.googleId;
      // data.mobile = '7897878894';
      // data.password = '112345678';
      data.organizationTypeID = accountType;
      data.organizationTypeName = accountTypeName;
      data.source = 1;
      submitData.demographicesDetails = data;
      registerOrgsSocial(submitData);
    } else if (response.profileObj) {
      registerFarmer(
        response.profileObj.email,
        response.profileObj.name,
        response.profileObj.googleId,
        1,
      );
    }
  };

  responseFacebook = (response) => {
    const {
      registerFarmer,
      accountType,
      accountTypeName,
      registerOrgsSocial,
    } = this.props;
    if (accountTypeName !== 'Farmer') {
      const submitData = {
        demographicesDetails: {},
      };
      const data = {};
      // const gName = response.name;
      const gNameSplit = response.name.split(' ');
      const [firstName, ...lastName] = gNameSplit;
      data.firstName = firstName;
      data.lastName = lastName.join(' ');
      data.emailID = response.email;
      data.googleId = response.userID;
      // data.mobile = '7897878894';
      // data.password = '112345678';
      data.organizationTypeID = accountType;
      data.organizationTypeName = accountTypeName;
      data.source = 2;
      submitData.demographicesDetails = data;
      registerOrgsSocial(submitData);
    } else if (response.profileObj) {
      registerFarmer(response.email, response.name, response.userID, 2);
    }
  };

  render() {
    // const { language } = this.context;
    return (
      <React.Fragment>
        {/*        <li className="redBtnHeader">
          <GoogleLogin
            clientId="1060241709387-h5qith1kjv1852tigcbvl2b45eq6d2gn.apps.googleusercontent.com"
            buttonText={(language.hindi && language.hindi.Login) || 'Login'}
            onSuccess={this.responseGoogle}
            onFailure={this.responseGoogle}
            render={renderProps => (
              <button
                type="button"
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
                className="gmai-Btn"
              >
                <img
                  src="/images/google.svg"
                  alt="google-logo"
                  title="google-logo"
                />
                <span>Gmail</span>
              </button>
            )}
          />
        </li> */}
        {/*        <li className="blueBtnHeader">
          <FacebookLogin
            appId="2493181310704890"
            callback={this.responseFacebook}
            fields="name, email, picture"
            scope="public_profile,email"
            // render={renderProps => (
            //   <Button
            //     variant="contained"
            //     color="primary"
            //     className="button blueBtn"
            //     onClick={renderProps.onClick}
            //   >

            //     {(language.hindi && language.hindi.Facebook) || 'Facebook'}
            //   </Button>
            // )}
            render={renderProps => (
              <button
                type="button"
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
                className="facebook-Btn"
              >
                <img
                  src="/images/fblogo.svg"
                  alt="fb-logo"
                  title="facebook-logo"
                />
                <span>Facebook</span>
              </button>
            )}
          />
        </li> */}
      </React.Fragment>
    );
  }
}

SocialLogin.contextType = LanguageContext;

export default withRouter(
  connect(
    ({ app }) => ({
      isRegistered: app.isRegistered,
      userData: app.userData,
    }),
    dispatch => ({
      registerFarmer: (email, name, userID, source) => {
        dispatch(registerFarmerSocialAction(email, name, userID, source));
      },
      registerOrgsSocial: (orgDetails) => {
        dispatch(registerOrgsSocialAction(orgDetails));
      },
    }),
  )(withCookies(SocialLogin)),
);
